import React, { useState, useRef, useEffect, forwardRef,useImperativeHandle, } from "react";
import { Box, IconButton, Typography, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { useQuery } from "@apollo/client"; 
import { GET_PROPERTY_NOTES } from "../../Graphql/Queries/propertiesQuery";
import ButtonReusable from "../../ButtonReusable";
import ReusableSpinner from "../../ReactTable/ReusableSpinner";
import { formatDateTimeWithHours,formatUserName,getNowDate } from "../../../utils";

const PropertyNotes = forwardRef(({ data, setState, notes: initialNotes = [],onNotesChange, contact_id, state }, ref,deleted) => {
  const [notes, setNotes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const property_id = data && data.arcimedes_row_id ? Number(data.arcimedes_row_id) : null
  const editRef = useRef(null);
 const [validationError, setValidationError] = useState("");
 
  const { loading: loadingContactNotes, data: ContactNotesData ,refetch} = useQuery(
    GET_PROPERTY_NOTES,
    {
       variables: {propertyId : property_id },
        skip : property_id == null,
      context: {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
    }
  );
//  Expose validate function to parent
  useImperativeHandle(ref, () => ({
    validateNotes: () => {
      // if no note is being edited -> consider valid
      if (!editingId) {
        setValidationError("");
        return true;
      }

      const currentNote = notes.find(
        (n) => (n.ARCIMEDES_ROW_ID || n.temp_id) === editingId
      );

      if (currentNote && currentNote.notes.trim() === "") {
        setValidationError("Note cannot be empty");
        return false;
      }

      setValidationError("");
      return true;
    },
  }));

  useEffect(()=>{
if(state.success === "Saved"){
   setEditingId(null);
   refetch()
}
  },[state])

  useEffect(() => {
  if (contact_id) {
    refetch();
  }
}, [contact_id, refetch]);
  
   useEffect(() => {
    if (onNotesChange) {
      onNotesChange(notes,editingId);
    }
  }, [notes, onNotesChange]);

  // sync server data
useEffect(() => {
  if (
    ContactNotesData &&
    ContactNotesData.getPropertyNotes &&
    ContactNotesData.getPropertyNotes.data !== null &&
    ContactNotesData.getPropertyNotes.data.length > 0
  ) {
    setNotes(ContactNotesData.getPropertyNotes.data);
  } else {
    setNotes([]); // default to empty array if data is null or empty
  }
}, [ContactNotesData]);


  const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = String(storedUserData.id) || "";

const fullName = formatUserName({
  firstName: storedUserData.firstName,
  lastName: storedUserData.lastName,
  username: storedUserData.username,
});
  const parseJWT = (token) => {
    if (token) {
      const base64Url = token.split(".")[1]; // The payload is the second part of the JWT
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  };
  const getUser = () => {
    var token = localStorage.getItem("authToken");
    // const decodedToken = parseJWT(token);
    // if (decodedToken.firstName || decodedToken.lastName) {
    //   return token ? `${decodedToken.firstName} ${decodedToken.lastName}` : "";
    // } else {
    //   return token ? decodedToken.username : "";
    // }
    const decodedToken = parseJWT(token);

    if (decodedToken.firstName && decodedToken.lastName) {
      // Both first & last name → first letters capitalized, no space
      const first = decodedToken.firstName.charAt(0).toUpperCase() + decodedToken.firstName.slice(1);
      const last = decodedToken.lastName.charAt(0).toUpperCase() + decodedToken.lastName.slice(1);
      return token ? `${first} ${last}` : "";
    }
    else if (decodedToken.firstName) {
      // Only first name → first letter capitalized
      return token ? decodedToken.firstName.charAt(0).toUpperCase() + decodedToken.firstName.slice(1) : "";
    }
    else if (decodedToken.lastName) {
      // Only last name → first letter capitalized
      return token ? decodedToken.lastName.charAt(0).toUpperCase() + decodedToken.lastName.slice(1) : "";
    }
    else {
      // Only username → first 2 letters capitalized
      return token ? decodedToken.username.slice(0, 2).toUpperCase() + decodedToken.username.slice(2) : "";
    }

  };

  const loggedinuser = getUser()

  // Add new note
const handleAddNote = () => {
  if (editingId) return;
  const newNote = {
    temp_id: Date.now(),         // temporary unique key for UI
    user_id,
    user_name: fullName,
    NOTES: "",
    date: getNowDate(),
    deleted: null,
    CREATED_BY:fullName
  };
  setNotes((prev) => [newNote, ...prev]);
  setEditingId(newNote.temp_id);
  setState((prev) => ({
    ...prev,
    viewMode: false,
    success:null
  }));
};

// Edit note text and update date
const handleChange = (id, value) => {
  setNotes(prevNotes =>
    prevNotes.map(note => {
      const currentId = note.ARCIMEDES_ROW_ID || note.temp_id;
      if (currentId === id) {
        return { 
          ...note, 
          NOTES: value, 
          date: getNowDate(), 
          user_name: fullName 
        };
      }
      return note;
    })
  );
   if (value.trim() === "") {
      setValidationError("Note cannot be empty");

    } else {
      setValidationError("");
    }
};



// Delete note (soft delete)
const handleDeleteMessage = (note) => {
    setState((prev) => ({
    ...prev,
    viewMode: false,
  }));
  const id = note.ARCIMEDES_ROW_ID !== null && note.ARCIMEDES_ROW_ID !== undefined
    ? note.ARCIMEDES_ROW_ID
    : note.temp_id;

  setNotes(prevNotes => prevNotes.map(n => {
    const currentId = n.ARCIMEDES_ROW_ID !== null && n.ARCIMEDES_ROW_ID !== undefined
      ? n.ARCIMEDES_ROW_ID
      : n.temp_id;
    if (currentId === id) {
      return { ...n, deleted: 1 };
    }
    return n;
  }));

  setEditingId(null)
};
;



 useEffect(() => {
    const handleClickOutside = (event) => {
      if (editRef.current && !editRef.current.contains(event.target)) {
        const currentNote = notes.find(
          (n) => (n.ARCIMEDES_ROW_ID || n.temp_id) === editingId
        );
        if ((currentNote && currentNote.NOTES.trim() === "") ) {
          setValidationError("Note cannot be empty");
          return; // don't close edit mode if empty
        }
        setEditingId(null);
        setValidationError("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editingId, notes]);

useEffect(() => {
  setState((prev) => ({
    ...prev,
    notes: notes,  //  append latest notes into parent state
  }));
}, [notes, data]);
  return (
    <React.Fragment>
      {loadingContactNotes ? (
        <ReusableSpinner />
      ) : (
        <div>
          <ButtonReusable
            onClick={handleAddNote}
            disabled={!!editingId || data.deleted == 1}
          >
            Add Notes
          </ButtonReusable>
          {notes
            .filter((note) => note.deleted !== 1)
            .map((note) => (
              <Box
                key={note.ARCIMEDES_ROW_ID || note.temp_id}
                sx={{
                  backgroundColor: "white",
                  border: "1px solid green",
                  color: "black",
                  width: "800px",
                  maxWidth: "100%",
                  mb: 2,
                  borderRadius: "6px",
                  p: 1.5,
                  boxShadow: 1,
                }}
              >
                {/* Header: date + username + actions */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", fontSize: "13px" }}
                  >
                    {formatDateTimeWithHours(
                      note.MODIFIED ? note.MODIFIED : note.date
                    )} {note.CREATED_BY}:
                  </Typography>

                  {/* {note.user_id === user_id && ( */}
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <IconButton
                      size="small"
                      disabled={
                        (loggedinuser &&
                          note &&
                          note.CREATED_BY &&
                          loggedinuser.toLowerCase() !==
                            note.CREATED_BY.toLowerCase()) ||
                        data.deleted == 1
                      }
                      onClick={() => {
                        // prevent action
                        const id = note.ARCIMEDES_ROW_ID || note.temp_id; // support both
                        setEditingId(id);
                        setState((prev) => ({
                          ...prev,
                          viewMode: false,
                          success: null,
                        }));
                      }}
                      sx={{
                        color:
                          (loggedinuser &&
                            note &&
                            note.CREATED_BY &&
                            loggedinuser.toLowerCase() !==
                              note.CREATED_BY.toLowerCase()) ||
                          data.deleted == 1
                            ? "grey.400"
                            : "#90C54B",
                      }}
                    >
                      <EditIcon
                        disabled={
                          (loggedinuser &&
                            note &&
                            note.CREATED_BY &&
                            loggedinuser.toLowerCase() !==
                              note.CREATED_BY.toLowerCase()) ||
                          data.deleted == 1
                        }
                        sx={{
                          color:
                            (loggedinuser &&
                              note &&
                              note.CREATED_BY &&
                              loggedinuser.toLowerCase() !==
                                note.CREATED_BY.toLowerCase()) ||
                            data.deleted == 1
                              ? "grey.400"
                              : "#90C54B",
                        }}
                        fontSize="small"
                      />
                    </IconButton>

                    <IconButton
                      size="small"
                      disabled={
                        (loggedinuser &&
                          note &&
                          note.CREATED_BY &&
                          loggedinuser.toLowerCase() !==
                            note.CREATED_BY.toLowerCase()) ||
                        data.deleted == 1
                      }
                      onClick={() => handleDeleteMessage(note)}
                      sx={{
                        color:
                          (loggedinuser &&
                            note &&
                            note.CREATED_BY &&
                            loggedinuser.toLowerCase() !==
                              note.CREATED_BY.toLowerCase()) ||
                          data.deleted == 1
                            ? "grey.400"
                            : "red",
                      }}
                    >
                      <DeleteIcon
                        disabled={
                          (loggedinuser &&
                            note &&
                            note.CREATED_BY &&
                            loggedinuser.toLowerCase() !==
                              note.CREATED_BY.toLowerCase()) ||
                          data.deleted == 1
                        }
                        sx={{
                          color:
                            (loggedinuser &&
                              note &&
                              note.CREATED_BY &&
                              loggedinuser.toLowerCase() !==
                                note.CREATED_BY.toLowerCase()) ||
                            data.deleted == 1
                              ? "grey.400"
                              : "red",
                        }}
                        fontSize="small"
                      />
                    </IconButton>
                  </Box>
                  {/* )} */}
                </Box>

                {/* Body: editable text or static */}
                <Box
                  ref={
                    editingId === (note.ARCIMEDES_ROW_ID || note.temp_id)
                      ? editRef
                      : null
                  }
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    fontSize: "14px",
                  }}
                >
                  {editingId === (note.ARCIMEDES_ROW_ID || note.temp_id) ? (
                    <TextField
                      fullWidth
                      multiline
                      minRows={3}
                      type="text"
                      value={note.NOTES}
                      onChange={(e) =>
                        handleChange(
                          note.ARCIMEDES_ROW_ID || note.temp_id,
                          e.target.value
                        )
                      }
                      placeholder="Type your notes here..."
                      error={!!validationError}
                      helperText={validationError}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "6px",
                          "& fieldset": { borderColor: "green" },
                          "&:hover fieldset": { borderColor: "darkgreen" },
                          "&.Mui-focused fieldset": {
                            borderColor: "green",
                            borderWidth: 2,
                          },
                        },
                        "& textarea": { resize: "none" },
                      }}
                    />
                  ) : (
                    <Typography variant="body2">{note.NOTES}</Typography>
                  )}
                </Box>
              </Box>
            ))}
        </div>
      )}
    </React.Fragment>
  );
});

export default PropertyNotes;
